import { Product, Category, ProductPrices, Lot } from "./types"

export enum ActionType {
    SET_PRODUCTS = 'setProducts',
    UPDATE_PRODUCTS = 'updateProducts',
    REMOVE_PRODUCTS = 'removeProducts',
    SET_CATEGORIES = 'setCategories',
    UPDATE_CATEGORIES = 'updateCategories',
    REMOVE_CATEGORIES = 'removeCategories',
    UPDATE_PRODUCT_PRICES = 'updateProductPrices',
    REMOVE_PRODUCT_PRICES = 'removeProductPrices',
    UPDATE_LOTS = 'updateLots',
    REMOVE_LOTS = 'removeLots'
}

interface SetProducts {
    type: ActionType.SET_PRODUCTS
    payload: Product[]
}

interface UpdateProducts {
    type: ActionType.UPDATE_PRODUCTS
    payload: Product[]
}

interface RemoveProducts {
    type: ActionType.REMOVE_PRODUCTS
    payload: string[]
}

interface SetCategories {
    type: ActionType.SET_CATEGORIES
    payload: Category[]
}

interface UpdateCategories {
    type: ActionType.UPDATE_CATEGORIES
    payload: Category[]
}

interface RemoveCategories {
    type: ActionType.REMOVE_CATEGORIES
    payload: string[]
}

interface UpdateProductPrices {
    type: ActionType.UPDATE_PRODUCT_PRICES
    payload: ProductPrices[]
}

interface RemoveProductPrices {
    type: ActionType.REMOVE_PRODUCT_PRICES
    payload: string[]
}

interface UpdateLots {
    type: ActionType.UPDATE_LOTS
    payload: Lot[]
}

interface RemoveLots {
    type: ActionType.REMOVE_LOTS
    payload: string[]
}

export type ProductsAction =
    SetProducts |
    SetCategories |
    ProductsUpdateAction |
    ProductsRemoveAction

export type ProductsUpdateAction =
    UpdateProducts |
    UpdateCategories |
    UpdateProductPrices |
    UpdateLots

export type ProductsRemoveAction =
    RemoveProducts |
    RemoveCategories |
    RemoveProductPrices |
    RemoveLots
